var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.target,{tag:"component",attrs:{"sdk2WebTicket":_vm.sdk2WebTicket,"initialRevoke":_vm.initialRevoke,"captchaData":_vm.captchaData,"platform":_vm.platform},on:{"on-step":_vm.handleStep,"on-back":_vm.handleBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }